import { render, staticRenderFns } from "./displacement-image.vue?vue&type=template&id=db4be2e8&lang=pug&"
import script from "./displacement-image.vue?vue&type=script&lang=js&"
export * from "./displacement-image.vue?vue&type=script&lang=js&"
import style0 from "./displacement-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports